import { initChangeAvatar } from './change-avatar';
import { initChangePassword } from './change-password';
import { initEditProfileForm } from './edit-profile';
import initChangeLanguage from '../actions/change-language';

export function profile() {
	initChangeAvatar();
	initChangePassword();
	initEditProfileForm();
	initChangeLanguage();
}
